import { render, staticRenderFns } from "./TunnelWriteBody.vue?vue&type=template&id=3cc8e44a&scoped=true"
import script from "./TunnelWriteBody.vue?vue&type=script&lang=js"
export * from "./TunnelWriteBody.vue?vue&type=script&lang=js"
import style0 from "./TunnelWriteBody.vue?vue&type=style&index=0&id=3cc8e44a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc8e44a",
  null
  
)

export default component.exports